<template>

    <FlashNotifications ref="flash" />
    <div class="pt-0 md:mt-10 mb-10">
        <div class="gap-6">
          <div class="md:mt-5 w-full md:flex gap-6 p-5 md:p-0 bg-white md:bg-transparent dark:bg-gray-700 md:dark:bg-transparent">
              <div class="px-6 py-7 bg-white rounded-lg border border-gray-300 md:shadow-lg md:shadow-gray-300 md:w-3/5 dark:border-gray-500 dark:bg-gray-700 dark:shadow-gray-500">
                <form @submit.prevent="submitUrl">
                  <label class="text-gray-700 block font-medium leading-5 dark:text-gray-200" for="payment_page_url">{{ I18N.application.integrations.external_payments.payment_page_url }}:</label>
                  <p class="text-gray-500 text-sm pt-1 dark:text-gray-400">{{ parseLocale(I18N.application.integrations.external_payments.subheading1, {application_name: APPLICATION_NAME }) }}</p>
                  <div class="flex">
                    <div class="flex-grow relative mt-3">
                      <p v-if="error" class="text-red-600 text-xs pr-1 pt-[2px] text-end">{{ error }}</p>
                      <input class="border-gray-300 text-sm rounded-lg w-full dark:bg-gray-600 dark:border-gray-500 dark:text-gray-200" type="text" v-model="externalPaymentIntegration.payment_page_url" required/>
                    </div>
                  </div>
                  <button type="submit" class="text-white bg-blue-600 hover:bg-blue-700 font-medium rounded-lg text-sm px-5 py-2 mt-5 text-center w-28">
                    {{ saveBtnText}}
                  </button>
                </form>
              </div>
              <div class="mt-6 md:mt-0 w-full p-4 bg-white rounded-lg border border-gray-300 md:shadow-lg  md:shadow-gray-300 md:w-2/5 dark:border-gray-500 dark:bg-gray-700 dark:shadow-gray-500">
                <div class="aspect-w-16 aspect-h-9">
<!--                  <iframe class="w-full aspect-video" src="https://www.youtube.com/embed/bjVX12NSw_0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>-->
                  <a href="https://www.youtube.com" target="_blank">
                    <img src="/images/youtube_thumbnail.jpg">
                  </a>
                </div>
<!--                <div class="mt-4">-->
<!--                  <h3 class="text-lg font-medium">External Payments Guidance</h3>-->
<!--                  <p class="text-sm text-gray-600">Here is a full guidance tutorial on how to set up external payments with Timelydo.</p>-->
<!--                </div>-->
              </div>
          </div>
          <div class="w-full">
            <div>
              <div class="md:mt-6 px-6 py-7 bg-white md:rounded-lg border-t md:border border-gray-300 md:shadow-lg md:shadow-gray-300 dark:border-gray-500 dark:bg-gray-700 dark:shadow-gray-500">
                <div>
                    <h3 class="text-xl font-medium text-gray-700 dark:text-gray-200">API docs</h3>
                    <p class="text-sm text-gray-600 dark:text-gray-400">Welcome to the Timelydo API! You can use our API to access Kittn API endpoints, which can get information on various cats, kittens, and breeds in our database.</p>
                    <img class="h-[500px]" src="/images/flowchart1.png">                
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  
</template>

<script>
import RequestMixin from "controllers/vue_components/mixins/request"
import Constants from "controllers/vue_components/mixins/constants"
import FlashNotifications from "controllers/vue_components/flash_toast"

export default {
    name: 'ExternalPayments',
    props: ['external_payments_integration'],
    components: {
        FlashNotifications
    },
    mixins: [RequestMixin, Constants],
    data() {
        return {
            externalPaymentIntegration: {},
            error: '',
        }
    },
    methods: {
        async submitUrl() {
            let request_type = 'POST';
            let endpoint = '/api/v1/integrations/external_payments_integrations';
            if (this.externalPaymentIntegration.id !== 'NOT_AVAILABLE') {
                request_type = 'PUT';
            }

            try {
                let data = {
                    external_payments_integration: {
                        payment_page_url: this.externalPaymentIntegration.payment_page_url,
                    },
                };

                let res = await this.axiosRequest(request_type, endpoint, data, false);

                if (res.js_error === false && res.response.success) {
                    this.externalPaymentIntegration = res.response.data.external_payments_integration;
                    this.$refs.flash.show(res.response.message, 'notice');
                    this.error = '';
                } else {
                    if (this.externalPaymentIntegration.payment_page_url.trim() === '') {
                        this.error = this.I18N.validations.payment_page_url_cant_be_blank
                    } else {
                        this.error = res.error.data.message;
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },


    },

    computed: {
        isNewExternalPaymentIntegration() {
            if(this.externalPaymentIntegration.id === 'NOT_AVAILABLE') {
                return true
            } else {
                return false
            }
        },
        saveBtnText() {
            if(this.isNewExternalPaymentIntegration) {
               return  this.I18N.application.integrations.external_payments.submit
            } else {
               return  this.I18N.application.integrations.external_payments.update
            }
        },
    },
    created() {
        this.externalPaymentIntegration = JSON.parse(this.external_payments_integration)
        if(this.externalPaymentIntegration === null) {
            this.externalPaymentIntegration = {
                payment_page_url: '',
              id: 'NOT_AVAILABLE',
            }
        }
    }
};
</script>
